<template>
  <div>
      <Row>
        <Col span="3" >
          <Content>
            <el-input placeholder="请输入体检任务名称"  prefix-icon="el-icon-search" v-model="search.taskName"/>
            <el-table ref="table" :data="taskList" highlight-current-row highlight-selection-row :show-header="false"
                      :max-height="maxHeight" :row-class-name="tableRowClassName" @row-click="handleRowClick">
              <el-table-column fixed prop="name" show-overflow-tooltip  max-width="50"/>
            </el-table>
          </Content>
        </Col>
        <Col span="21">
          <ErrorReportList ref="errorReportList" :currentRowIndex="currentRowIndex"
                :taskId.sync="taskId" :style="{'overflow-y':'auto','box-sizing':'border-box'}"/>
        </Col>
      </Row>
  </div>
</template>
<script>

import {_taskList} from "@/services/studentManage/studentManage";
import ErrorReportList from "./ErrorReportList.vue"

export default {
  name: "ErrorReport",
  components: {ErrorReportList},
  data() {
    return {
      search: {
        taskName: "",
      },
      maxHeight: window.innerHeight - 200,
      currentRowIndex: -1,
      taskList: [],
      taskId: "",
    };
  },
  watch: {
    'search.taskName': {
      handler(newVal) {
        this.$nextTick(()=>{
          setTimeout(() => {
            this.applyTaskList();
          }, 500)
        });
      }
    },
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.applyTaskList();
    }
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.maxHeight = `${height - 135}px`;
    },
    tableRowClassName(row) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "current-row";
      }
    },
    handleRowClick(row, column, event){
      this.currentRowIndex = row.index;
      this.taskId = row.id;
    },
    applyTaskList(){
      this.taskList = [];
      _taskList(this.search).then(res=>{
        if (res.errcode === 1 && res.data) {
          this.taskList = Object.assign([], res.data);
        }
      }).catch(e=>{})
    },

  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table th {
  background-color: #f8f8f9;
  font-weight: bold;
}

/deep/ .el-table thead {
  color: #515a6e;
  font-weight: 500;
}

/*.el-table{
  border: 1px solid #ccc;
}*/

/deep/ .el-table__body tr.current-row>td.el-table__cell, .el-table__body tr.selection-row>td.el-table__cell {
  background-color: #beffc5;
}

/deep/ .el-table .current-row td{
  background: #beffc5;
  color: #101010;
}

/deep/ .ivu-table .current-row td{
  background: #beffc5;
  color: #101010;
}

/* 移除外层包裹的伪元素边框 */
/deep/ .el-table::before {
  height: 0 !important;  /* 底部外边框 */
}

/deep/ .el-table__fixed::before,
/deep/ .el-table__fixed-right::before {
  width: 0 !important;  /* 移除固定列左侧分隔线 */
}

/* 清除带有 border 属性的表格边框 */
/deep/ .el-table--border,
/deep/ .el-table--group {
  border: none !important;  /* 完全移除外框线 */
}

/deep/ .el-table td.el-table__cell,
/deep/ .el-table th.el-table__cell {
  border: none !important;  /* 移除单元格所有边框 */
}
</style>
